<template>
  <div
    v-if="
      selectedVacant.status == 'TEST' || selectedVacant.status == 'TEST_PROCESS'
    "
  >
    <div v-if="selectedVacant.testOfferSubmit">
      <loading
        :active.sync="loader"
        :is-full-page="true"
        loader="bars"
      ></loading>
      <div class="p-7">
        <b-modal
          :no-close-on-backdrop="true"
          :hide-header="true"
          :ok-title="$t('actions.yes')"
          :cancel-title="$t('actions.no')"
          @close="cancel"
          @cancel="cancel"
          @ok="ok"
          v-model="isModalAnswers"
        >
          <template v-slot:modal-footer>
            <b-button @click="isModalAnswers = false" variant="light">
              {{ $t("actions.no") }}
            </b-button>
            <b-button @click="ok" :disabled="loaderSave" variant="success">
              <b-overlay opacity="0.1" rounded="sm" :show="loaderSave">
                {{ $t("actions.yes") }}
              </b-overlay>
            </b-button>
          </template>
          <p>{{ $t("finishSure") }}</p>
        </b-modal>
        <div id="app" v-if="!loader">
          <b-container class="con">
            <b-card no-body>
              <b-card-header class="bg-white sticky-top">
                <b-row>
                  <b-col></b-col>
                  <b-col lg="3">
                    <div>
                      <b-button class="mb-2 pt-2 pb-2" block variant="warning">
                        <article class="clock" id="model3">
                          <div class="count">
                            <h4
                              id="timer"
                              class="m-0"
                              style="min-height: 24px"
                            ></h4>
                          </div>
                        </article>
                        <!-- <vue-countdown-timer
                        @end_callback="endCallBack"
                        :start-time="dateNow"
                        :end-time="expireDate"
                        :interval="1000"
                        :end-text="'Vaqt tugadi'"
                      >
                        <template slot="countdown" slot-scope="scope">
                          <span>{{
                            `${scope.props.minutes} : ${scope.props.seconds}`
                          }}</span>
                        </template>
                      </vue-countdown-timer> -->
                      </b-button>
                    </div>
                  </b-col>
                  <b-col></b-col>
                </b-row>
              </b-card-header>
              <b-card-body>
                <b-container
                  v-for="(item, index) in questionsDtoComp"
                  :key="index"
                >
                  <h5 class="mb-3">
                    <strong>{{ index + 1 }}.</strong>
                    <strong>
                      {{ item[$localeKey()] }}
                    </strong>
                  </h5>
                  <b-form-radio-group
                    size="lg"
                    v-model="item.answer"
                    :disabled="loadingOpt"
                  >
                    <b-form-radio
                      style="display: block"
                      v-for="(choice, i) in item.answers"
                      :key="i"
                      :value="choice.id + ', ' + item.id"
                      @change="selectOptions(item.id, choice.id)"
                    >
                      <p style="line-height: 25px">
                        {{ choice[$localeKey()] }}
                      </p>
                    </b-form-radio>
                  </b-form-radio-group>
                </b-container>
              </b-card-body>
              <b-card-footer class="bg-white">
                <b-row>
                  <b-col> </b-col>
                  <b-col md="12" lg="2" sm="4"> </b-col>
                  <b-col md="12" lg="3" sm="4">
                    <b-button
                      block
                      @click="openModal"
                      variant="primary"
                      class="float-right"
                      >{{ $t("actions.finishTest") }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-footer>
            </b-card>
          </b-container>
        </div>
      </div>
    </div>
    <div v-else>
      <b-row class="mt-4">
        <b-col lg="1" xs="12"></b-col>
        <b-col lg="10" xs="12">
          <b-card>
            <b-card-header v-html="getTitleByCode('test_rules')[$localeKey()]">
            </b-card-header>
            <b-card-body>
              <b-row>
                <b-form-checkbox size="lg" v-model="isAgreeCheckbox"
                  >{{ $t('agreeTest') }}
                </b-form-checkbox>
              </b-row>
              <b-row class="mt-3 p-0">
                <b-col></b-col>
                <b-col lg="2" xs="6" class="p-0 mr-2">
                  <b-button
                    class="mt-2"
                    variant="outline-primary"
                    block
                    @click="$emit('cancel')"
                  >
                    <i class="fa fa-arrow-left"></i>
                    {{ $t("actions.back") }}
                  </b-button>
                </b-col>
                <b-col lg="2" xs="6" class="p-0">
                  <b-button
                    class="mt-2"
                    variant="primary"
                    block
                    :disabled="!isAgreeCheckbox"
                    @click="agree"
                    >{{ $t("references.accept") }}
                  </b-button>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col lg="1" xs="12"></b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import vacancyService from "@/services/vacancy.service";
import Loading from "vue-loading-overlay";
import TestResultCandidates from "../cadr/testResultForCandidates";
import "vue-loading-overlay/dist/vue-loading.css";
const v = {
  components: {
    Loading,
    TestResultCandidates,
  },

  async created() {
    let id = this.getId();
    if (id) {
      await this.getVacantById(id);
    }
    this.$nextTick(() => {
      this.idTemp = id;
    });
  },
  data: () => {
    return {
      userTestresult: null,
      resultLoader: false,
      loader: false,
      tempId: null,
      selectedVacant: {},
      boxTwo: "",
      isAgreeCheckbox: false,
      questionsDto: [],
      testEmployee: null,
      isModalAnswers: false,
      snackbar: true,
      expireDate: Date.now() + 60 * 30 * 1000,
      dateNow: new Date(Date.now()),
      loaderSave: false,
      loadingOpt: false,
      currentId: null,
    };
  },
  computed: {
    ...mapState("employee", ["employee", "employeeTestResult"]),

    ...mapState("vacancy", ["isAgreement"]),
    ...mapGetters("testcrud", ["startGetter", "endGetter"]),
    ...mapGetters("title", ["getTitleByCode"]),
    questionsDtoComp() {
      return this.questionsDto.map((el) => {
        let selected = el.answers.filter((opt) => opt.isSelect)[0];
        if (!selected) {
          el.answer = "";
        } else {
          el.answer = selected.id + ", " + el.id;
        }

        return el;
      });
    },
  },
  methods: {
    ...mapActions("employee", ["getEmployee"]),
    async selectOptions(questionId, answerId) {
      let payload = {
        id: this.testEmployee.id,
        questionId,
        answerId,
      };
      this.currentId = questionId;
      this.loadingOpt = true;
      try {
        let resData = (await vacancyService.testSubmit(payload)).data;
        this.$nextTick(() => {
          this.questionsDto = [...resData];
        });
      } catch {
        this.$toast.error(
          "Siz oflaynsiz! Iltimos internetga ulanganingizni qayta tekshirib ko'ring"
        );
      } finally {
        this.loadingOpt = false;
      }
    },
    paginatedDate() {
      let copyArray = [...this.questionsDto];
      // let array = copyArray.slice(
      //   parseFloat(this.startGetter),
      //   parseFloat(this.endGetter)
      // );
      return copyArray;
    },

    setCountDown: (v, vm, t) => {
      // let vm = this;

      function secpass(vm_inner) {
        let countDiv = document.getElementById("timer");
        if (!countDiv) {
          clearInterval();
        } else {
          let min = Math.floor(sec / 60),
            remSec = sec % 60;

          if (remSec < 10) {
            remSec = "0" + remSec;
          }
          if (min < 10) {
            min = "0" + min;
          }
          countDiv.innerText = min + ":" + remSec;

          if (sec > 0) {
            sec = sec - 1;
          } else {
            clearInterval(countDown);

            countDiv.innerHTML = "Vaqt tugadi";
            vm_inner.sendAnswer();
          }
        }
      }

      let sec = parseFloat(v),
        countDown = setInterval(function () {
          "use strict";
          secpass(vm);
        }, 1000);
    },
    endCallBack: async function () {
      await this.sendAnswer();
      await this.$toast.info("Vaqt tugadi");
      await this.$router.push("/profile");
    },
    getVacantById() {
      this.loader = true;
      let id = this.getId();
      vacancyService.getVacantById(id).then(async (res) => {
        if (res.data) {
          this.$nextTick(() => {
            this.selectedVacant = res.data;
          });
          if (res.data.status == "TEST_PROCESS") {
            await this.getTestByVacancyId(id);
          } else {
            this.loader = false;
          }
        }
      });
    },

    showMsgBoxTwo() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(this.$t("warning.finishTest"), {
          // title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
        })
        .catch((err) => {
          // An error occurred
        });
    },
    async ok() {
      await this.sendAnswer();
    },
    async okTestresult() {
      await this.$router.push("/profile");
    },
    async next() {
      await this.$store.commit("testcrud/next");
    },
    async prev() {
      await this.$store.commit("testcrud/prev");
    },
    async updatePage(index) {
      await this.$store.commit("testcrud/setPage", index);
    },
    cancel() {
      this.isModalAnswer = false;
    },
    async cancelTestresult() {
      this.resultLoader = false;
      await this.$router.push("/profile");
    },

    openModal() {
      this.isModalAnswers = !this.isModalAnswers;
    },

    async sendAnswer(h) {
      let answer = this.questionsDto
        .filter((el) => el.answer != undefined)
        .map((el) => el.answer);
      const obj = {};

      for (const key of answer) {
        obj[key.split(", ")[1]] = key.split(", ")[0];
      }
      await this.$set(this.testEmployee, "questionAnswer", obj);
      this.loaderSave = true;

      await vacancyService
        .sendAnswer(this.getId())
        .then((res) => {
          this.$store.commit("employee/setEmployeeTestResult", res.data);
        })
        .catch((error) => {
          this.resultLoader = false;
          this.$toast.error(
            error.request.response === "Date has been Expired..."
              ? this.$t("expireDateMessage")
              : "Error"
          );
        })
        .finally(() => {
          this.loaderSave = false;
          this.getVacantById();
          this.$router.push("/testResultCandidates");
        });
    },

    setRandomTestList(data) {
      if (data) {
        this.questionsDto = data.questionsDto;
        this.testEmployee = data.testEmployee;
        this.$forceUpdate();
      }
    },

    getTestByVacancyId(id, boolean) {
      this.loader = true;
      vacancyService
        .getTestByVacancyId(id)
        .then(async (res) => {
          if (res.data) {
            await this.setRandomTestList(res.data ? res.data : null);

            await this.setCountDown(
              res.data.testEmployee.expirationTime,
              this,
              "first"
            );

            if (boolean) {
              await this.updateStatus(id);
            } else {
              this.loader = false;
            }
          }
        })
        .catch(async (e) => {
          await this.setRandomTestList(null);
          await this.$router.push("/profile");
          await this.$toast.error(e.request.response.details[0] || e.request.response);
        });
    },
    getId() {
      try {
        let id = window.atob(this.$route.query.id);
        let array = id.split("W29iam");
        let exId = array[1].split("test_status")[0];
        return parseInt(exId);
      } catch (error) {
        this.$router.push("/profile");
        this.$toast.error("error");
        return false;
      }
    },
    async updateStatus(id) {
      this.loader = true;
      await vacancyService.getVacantById(id).then(async (res) => {
        this.$nextTick(() => {
          this.selectedVacant = res.data;
          this.loader = false;
          window.location.reload();
        });
      });
    },
    async agree() {
      let id = await this.getId();
      if (id) {
        await this.getTestByVacancyId(id, true);
      }
    },
  },
};

export default v;
</script>

<style>
.con {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}

.wrapp {
  height: 5.3vh;
  width: 5.3vh;
  display: flex;
  justify-content: center;
  align-items: center;
  border: thin solid rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
}

.v-icon.v-icon {
  font-size: 20px;
}

.boxPage:hover {
  cursor: pointer;
}

.wrapDiv {
  display: flex;
  flex-wrap: wrap;
}
.sticky-top {
  align-self: flex-start;
  width: 100%;
}
</style>
